import { render } from "./CardLink.vue?vue&type=template&id=f91945fc"
import script from "./CardLink.vue?vue&type=script&lang=js"
export * from "./CardLink.vue?vue&type=script&lang=js"

import exportComponent from "/home/christian/dev/pingcrm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__